import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LoggedUser } from 'src/app/modules/auth/state/action';
import {
  LoadQuickLinks,
  LoadRoleMenus,
  LoadUserApplications,
  LoadUserCostCenters,
  LoadUserEvents,
} from 'src/app/state/userMap.action';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss'],
})
export class FullComponent implements OnInit {
  entity: any;
  show: boolean= false;
  CurrentUrl: string = '';
  url:string='';
  result:any=[];
  curl:string;
  cresult:any=[];

  constructor(private store: Store, private router: Router) {
    this.store.dispatch(LoggedUser());
    this.store.dispatch(LoadUserCostCenters());
    this.store.dispatch(LoadUserApplications());
    this.store.dispatch(LoadUserEvents());
    this.store.dispatch(LoadQuickLinks());
    this.CurrentUrl = this.router.url;
  }

  ngOnInit(): void {
    this.router.events
    .subscribe((event: NavigationEnd) => 
     {
      
       this.url = event.url;
      if (this.url){
       this.result = this.url.split('/');
      }

      if(this.entity != 11  && event.url != '/dashboard' && this.result[1] != 'alumni' ){
        this.show = true;
      }else{
        this.show = false;
      }
     });
    
    this.entity = localStorage.getItem('entity');
     
    this.curl = this.CurrentUrl;
    this.cresult = this.curl.split('/'); 

    if( this.cresult[1] == 'alumni'){
      this.show = false;
    }
    else if(this.entity != 11  && this.CurrentUrl != '/dashboard'){
      this.show = true;
    }
    else{
      this.show = false;
    }
  }
}
